<template>
  <div class="author-wrap">
    <vue-scroll
      ref="vueScroll"
      @handle-scroll="handleScroll"
    >
      <PersonalHeader :info="personalInfo" />
      <div class="bd">
        <PersonalAuthor :info="personalInfo" />
        <div
          v-if="list.length"
          class="list"
        >
          <ul>
            <li
              v-for="item in list"
              :key="item.wid"
              class="item"
              :data-wid="item.wid"
              @click="handleViewDetail"
            >
              <PersonalWallpaperItem
                :data="item"
                @view="handleShowDetail"
              />
            </li>
          </ul>
        </div>
        <div
          v-if="hadFetchInfo && !list.length"
          class="empty"
        >
          <span class="txt">TA很懒，还没有上传过壁纸</span>
        </div>
      </div>
    </vue-scroll>
  </div>
</template>

<script>
// import { mapState } from 'vuex'

import { fetchInfo, fetchWorks } from '@/api/author'

import PersonalHeader from '@/components/PersonalHeader'
import PersonalAuthor from '@/components/PersonalAuthor'
// import PersonalNav from '@/components/PersonalNav'
import PersonalWallpaperItem from '@/components/PersonalWallpaperItem'

// 作者作品接口：1 同时查询动态和场景壁纸；2 仅查询场景，会遗漏视频作品。
const WTYPE_DYNAMIC_AND_SENCE = 1
const WTYPE_STATIC = 3
const SCROLL_RATE = 1.8

export default {
  name: 'Author',
  components: {
    PersonalHeader,
    PersonalAuthor,
    // PersonalNav,
    PersonalWallpaperItem,
  },
  data() {
    let uid = 0
    const query = this.$route.query
    if (+query.author_uid) {
      uid = +query.author_uid
    }
    return {
      uid,
      personalInfo: {},
      wtype: WTYPE_DYNAMIC_AND_SENCE,
      list: [],
      page: 1,
      pageSize: 54,
      total: 0,
      isEmpty: false,
      panelHeight: 0,
      contentHeight: 0,
      loading: false,
      listEnd: false,
      hadFetchInfo: false,
      currentUser: { uid: '' },
    }
  },
  mounted() {
    this.fetchInfo()
    this.fetchWorks()
  },
  methods: {
    showEmpty() {
      this.isEmpty = true
    },
    hideEmpty() {
      this.isEmpty = false
    },
    handleViewDetail($event) {
      const wid = +$event.currentTarget.dataset.wid
      if (wid) {
        this.$router.push({
          path: '/personal/wallpaper',
          query: {
            dwid: wid,
          },
        })
      }
    },
    handleScroll({ scrollTop }) {
      if (!this.panelHeight) {
        this.panelHeight = this.$refs.vueScroll.scrollPanelElm.offsetHeight
      }

      if (this.loading) {
        return
      }

      if (this.listEnd) {
        return
      }

      if (!Object.keys(this.list).length) {
        return
      }

      this.contentHeight = this.$refs.vueScroll.scrollContentElm.offsetHeight

      if (scrollTop < this.contentHeight - this.panelHeight * SCROLL_RATE) {
        return
      }

      this.fetchInfiniteData()
    },
    handleSwitch(params = {}) {
      if (params.type === 'dynamic') {
        if (this.wtype === WTYPE_DYNAMIC_AND_SENCE) {
          return
        }
        this.wtype = WTYPE_DYNAMIC_AND_SENCE
      }

      if (params.type === 'static') {
        if (this.type === WTYPE_STATIC) {
          return
        }
        this.wtype = WTYPE_STATIC
      }

      this.page = 1
      this.fetchWorks()
    },
    handleShowDetail() {
      //
    },
    async fetchInfo() {
      try {
        const res = await fetchInfo({
          author_uid: this.uid,
        })

        if (res.resp_common && !res.resp_common.ret) {
          this.personalInfo = res.user_info
        }
      } catch (err) {
        // TODO
      }

      this.hadFetchInfo = true
    },
    async fetchWorks(options = {}) {
      const { isInfinite = false } = options
      if (!isInfinite) {
        this.list = []
      }

      try {
        this.loading = true
        const res = await fetchWorks({
          author_uid: this.uid,
          wtype_support: this.wtype,
          page_size: this.pageSize,
          page: this.page,
        })

        if (res.resp_common && !res.resp_common.ret) {
          this.total = res.data.total
          const list = res.data.list || []

          if (isInfinite) {
            this.list = this.list.concat(list)
          } else {
            this.list = list
          }
        }
      } catch (err) {
        // TODO
      }

      if (this.list.length) {
        this.hideEmpty()
      } else {
        this.showEmpty()
      }

      this.loading = false
    },
    async fetchInfiniteData() {
      if (this.listEnd) {
        return
      }

      if (!Object.keys(this.list).length) {
        return
      }

      this.loading = true
      this.page++

      try {
        await this.fetchWorks({
          isInfinite: true,
        })
      } catch (err) {
        // TODO
      }

      this.loading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.author-wrap {
  height: 100%;
}
.bd {
  width: 1280px;
  margin: 26px auto;
  padding-bottom: 20px;
  background: #fff;
  border-radius: 6px;
}
.list {
  margin-top: 20px;
  ul {
    &::after {
      content: '';
      display: table;
      clear: both;
    }
  }
  .item {
    float: left;
    margin-left: 13px;
    margin-bottom: 10px;
    cursor: pointer;
  }
}
.empty {
  padding: 50px 0;
  text-align: center;
  &::before {
    content: '';
    display: block;
    width: 282px;
    height: 216px;
    margin: 0 auto;
    background: url('~@/assets/images/empty.png') 0 0 no-repeat;
  }
  .txt {
    color: #333;
  }
}
</style>
